
import EoQuote from "../../EoQuote/EoQuote.vue"
import { overflowContainerMixin } from '../../../mixins'

export default {
  name: "PreprQuote",
  components: { EoQuote },
  mixins: [
    overflowContainerMixin,
  ],
  props: {
    /**
     * Prepr data of this element
     */
    data: {
      type: Object,
      default: () => {},
    },
    /**
     * Prop and attribute overwrites
     */
    overwrites: {
      type: Object,
      default: () => {
        return {}
      },
    },
    /**
     * Index
     */
    index: {
      type: Number,
      default: null,
    },
  },
  data () {
    return {
      overflowSetting: null,
      dataModel: {
        quote: {
          body: null,
        },
        author: {
          body: null,
        },
        source: {
          body: null,
        },
        profile_picture: {
          items: [{
            label: null,
            body: null,
            cdn_files: {
              items: [{
                url: null,
              }],
            },
          }],
        },
      },
    }
  },
  computed: {
    normalizedData () {
      return {...this.dataModel, ...this.data}
    },
    imageUrl () {
      return this.normalizedData.profile_picture.items[0].cdn_files.items[0].url;
    },
    styles () {
      return this.$viewport.mdAndUp && Number(this.overflowSetting) !== 0 && this.overflowSetting !== 'none'
        ? {
          marginLeft: `-${this.overflowOffset}px`,
          maxWidth: '400px',
          marginRight: `30px`,
          float: 'left',
        }
        : {
          ...this.overflowStyles,
          paddingLeft: `${this.overflowOffset * 2}px`,
          paddingRight: `${this.overflowOffset * 2}px`,
        }
    },
  },
  created () {
    this.overflowSetting = this.overwrites.overflowContainer || '10'
  },
}
